import React from 'react';
// TODO: should be refactored
export const Spinner = props => (
    <div
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
        }}
    >
        <div className="lds-spinner">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/UI/Components/Spiner/Spiner.js